import { render } from "./RootView.vue?vue&type=template&id=38e8431e&scoped=true"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"

import "./RootView.vue?vue&type=style&index=0&id=38e8431e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e8431e"]])

export default __exports__